// Botón "Compartir" de la ficha: comparte con el menú del sistema o copia el enlace
if (!customElements.get('cdc-compartir')) {
  customElements.define(
    'cdc-compartir',
    class CdcCompartir extends HTMLElement {
      connectedCallback() {
        this.boton = this.querySelector('button');
        this.texto = this.querySelector('[data-texto]');
        this.textoOriginal = this.texto.textContent;
        this.boton.addEventListener('click', () => this.compartir());
      }

      async compartir() {
        const datos = { title: this.dataset.titulo, url: window.location.href };
        if (navigator.share) {
          try {
            await navigator.share(datos);
          } catch (error) {
            // El usuario ha cerrado el menú de compartir
          }
          return;
        }

        try {
          await navigator.clipboard.writeText(datos.url);
          this.avisar('Enlace copiado');
        } catch (error) {
          this.avisar('No se pudo copiar');
        }
      }

      avisar(mensaje) {
        this.texto.textContent = mensaje;
        clearTimeout(this.temporizador);
        this.temporizador = setTimeout(() => {
          this.texto.textContent = this.textoOriginal;
        }, 2000);
      }
    }
  );
}

// Barra de compra fija en móvil: aparece cuando el botón principal se queda por encima de la pantalla
if (!customElements.get('cdc-barra-compra')) {
  customElements.define(
    'cdc-barra-compra',
    class CdcBarraCompra extends HTMLElement {
      connectedCallback() {
        // La columna de compra tiene una animación de entrada con transform, que rompe el position: fixed
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > cdc-barra-compra').forEach((anterior) => anterior.remove());
          document.body.appendChild(this);
          return;
        }

        this.ficha = document.querySelector('product-info[id^="MainProduct"]') || document.querySelector('product-info');
        if (!this.ficha) return;

        this.talla = this.querySelector('[data-talla]');
        this.precio = this.querySelector('[data-precio]');
        this.boton = this.querySelector('[data-boton]');

        this.boton.addEventListener('click', () => {
          const principal = this.botonPrincipal();
          if (principal && !principal.disabled && principal.getAttribute('aria-disabled') !== 'true') principal.click();
        });
        this.talla.addEventListener('click', () => {
          this.ficha.querySelector('variant-selects')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        this.alDesplazar = () => this.comprobar();
        window.addEventListener('scroll', this.alDesplazar, { passive: true });
        window.addEventListener('resize', this.alDesplazar, { passive: true });
        this.actualizar();
        this.comprobar();

        // pubsub.js y constants.js cargan con defer, igual que este archivo, pero pueden ir después
        const suscribir = () => {
          if (typeof subscribe !== 'function' || !this.isConnected) return;
          this.desuscribir = subscribe(PUB_SUB_EVENTS.variantChange, () => this.actualizar());
        };
        if (typeof subscribe === 'function') suscribir();
        else document.addEventListener('DOMContentLoaded', suscribir, { once: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.alDesplazar);
        window.removeEventListener('resize', this.alDesplazar);
        this.desuscribir?.();
        document.body.classList.remove('cdc-barra-visible');
      }

      botonPrincipal() {
        return this.ficha.querySelector('.product-form__submit');
      }

      // Visible solo cuando el botón principal ya ha quedado entero por encima de la pantalla
      comprobar() {
        const principal = this.botonPrincipal();
        this.mostrar(Boolean(principal) && principal.getBoundingClientRect().bottom < 0);
      }

      mostrar(visible) {
        if (visible === this.visible) return;
        this.visible = visible;
        if (visible) this.actualizar();
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.boton.tabIndex = visible ? 0 : -1;
        this.talla.tabIndex = visible ? 0 : -1;
        document.body.classList.toggle('cdc-barra-visible', visible);
      }

      actualizar() {
        const grupos = [...this.ficha.querySelectorAll('variant-selects .product-form__input')];
        const opciones = grupos
          .map((grupo) => {
            const elegido = grupo.querySelector('input:checked') || grupo.querySelector('select');
            const nombre = grupo.querySelector('legend, label.form__label')?.textContent.trim();
            return elegido && nombre ? `${nombre}: ${elegido.value}` : null;
          })
          .filter(Boolean);
        this.talla.textContent = opciones.join(' · ');
        this.talla.hidden = opciones.length === 0;

        const precio = this.ficha.querySelector('.price');
        const importe = precio?.classList.contains('price--on-sale')
          ? precio.querySelector('.price__sale .price-item--sale')
          : precio?.querySelector('.price__regular .price-item--regular');
        this.precio.textContent = importe ? importe.textContent.trim().replace(/\s+[A-Z]{3}$/, '') : '';

        const principal = this.botonPrincipal();
        if (principal) {
          const disponible = !principal.disabled;
          this.boton.disabled = !disponible;
          this.boton.textContent = principal.querySelector('span')?.textContent.trim() || this.boton.textContent;
        }
      }
    }
  );
}

// Galería ampliada de la ficha (product-modal de Dawn): en el móvil, el botón "atrás" la cierra en lugar de
// sacar de la ficha. Al abrirla se añade un paso al historial y al cerrarla con la X se quita.
if (!window.cdcZoomAtras) {
  window.cdcZoomAtras = true;

  const esGaleria = (elemento) => elemento.matches?.('product-modal');

  new MutationObserver((cambios) => {
    cambios.forEach(({ target }) => {
      if (!esGaleria(target)) return;
      if (target.hasAttribute('open')) {
        if (!window.history.state?.cdcZoom) window.history.pushState({ cdcZoom: true }, '');
      } else if (window.history.state?.cdcZoom) {
        window.history.back();
      }
    });
  }).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });

  window.addEventListener('popstate', () => {
    document.querySelectorAll('product-modal[open]').forEach((galeria) => galeria.hide());
  });
}
